import { ID_PARAMS, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import BillUpload from 'portal/src/components/billAutomation/BillUpload';
import FileUploadDetails from 'portal/src/components/billAutomation/FileUploadDetails/FileUploadDetails';
import SpreadsheetUpload from 'portal/src/components/billAutomation/SpreadsheetUpload';
import UtilityCredentials from 'portal/src/components/billAutomation/UtilityCredentials/UtilityCredentials';
import UtilityCredentialsForm from 'portal/src/components/billAutomation/forms/UtilityCredentials/UtilityCredentialsForm';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import BaseForm from 'portal/src/layouts/base/BaseForm';
import BillAutomationDashboard from 'portal/src/pages/billAutomation/BillAutomationDashboard';
import BillAutomationTableWithForm from 'portal/src/pages/billAutomation/BillAutomationLayout';
import { isBillAutomationTableEnabled } from 'portal/src/pages/billAutomation/billAutomationEnabled';

import { RouteDefinition } from './routeGenerator';

export const billAutomationRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <BillAutomationDashboard
        slug={DASHBOARD_SLUGS.BILL_AUTOMATION.SUMMARY}
        disabledSlug={DASHBOARD_SLUGS.BILL_AUTOMATION.PREVIEW}
      />
    ),
    name: 'Summary',
    path: NESTED_ROUTES.BILL_AUTOMATION.SUMMARY,
    description: 'Status of your bill automation',
  },
  {
    element: <BillAutomationTableWithForm />,
    children: [
      {
        element: (
          <BaseForm
            apiPath={API_BASE_PATHS.CREDENTIALS}
            Component={UtilityCredentialsForm}
          />
        ),
        path: ID_PARAMS.ANY,
      },
      {
        element: <UtilityCredentials />,
        index: true,
      },
    ],
    shouldRenderLink: isBillAutomationTableEnabled,
    name: 'Credentials',
    path: NESTED_ROUTES.BILL_AUTOMATION.CREDENTIALS,
    description: 'Manage your credentials and settings for your utilities',
  },
  {
    element: <BillAutomationTableWithForm />,
    children: [
      {
        element: (
          <BaseForm
            apiPath={API_BASE_PATHS.STATEMENTS}
            Component={FileUploadDetails}
          />
        ),
        path: ID_PARAMS.ANY,
      },
      {
        element: <BillUpload />,
        index: true,
      },
    ],
    shouldRenderLink: isBillAutomationTableEnabled,
    name: 'Bill Upload',
    path: NESTED_ROUTES.BILL_AUTOMATION.BILL_UPLOAD,
    description: 'Upload your bills for automated data entry',
  },
  {
    element: <BillAutomationTableWithForm />,
    children: [
      {
        element: (
          <BaseForm
            apiPath={API_BASE_PATHS.IMPORT_FILES}
            Component={FileUploadDetails}
          />
        ),
        path: ID_PARAMS.ANY,
      },
      {
        element: <SpreadsheetUpload />,
        index: true,
      },
    ],
    shouldRenderLink: isBillAutomationTableEnabled,
    name: 'Spreadsheet Upload',
    path: NESTED_ROUTES.BILL_AUTOMATION.SPREADSHEET_UPLOAD,
    description: 'Upload your spreadsheets for automated data entry',
  },
];
